// extracted by mini-css-extract-plugin
module.exports = {"container":"_9400a595a7--container--tBoLK","text":"_9400a595a7--text--HmuoO"};